import classNames from 'classnames';
import Immutable from 'immutable';
import React from 'react';
import { oneOfType, shape, string, array, object, instanceOf } from 'prop-types';
import { Editor } from '@ep/editor';
import { isJsonString } from '../../lib/utils';
import styles from '../../styles/textContent.module.styl';

const TextContent = ({ content, className }) => {
  const editorContent = isJsonString(content) ? JSON.parse(content) : content;
  return (
    <div className={classNames(styles.textEditor, className)}>
      <Editor readOnly={true} editorContent={editorContent} />
    </div>
  );
};

TextContent.propTypes = {
  content: oneOfType([
    string,
    shape({
      blocks: array,
      entityMap: object,
    }),
    instanceOf(Immutable.Map),
  ]).isRequired,
  className: string,
};

TextContent.defaultProps = {
  className: '',
};

export default TextContent;



// WEBPACK FOOTER //
// ./src/components/common/TextContent.js